import { Component, HostBinding, ViewEncapsulation, input } from '@angular/core';

@Component({
    selector: 'lay-panel',
    templateUrl: './panel.component.html',
    styleUrls: ['./panel.component.sass'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PanelComponent {
  @HostBinding('class') get classes() {
    return `${this.styleClass()}`;
  }

  readonly styleClass = input('');
}

/**
 * Used in Settings Lux
 */
